var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 14.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #009984;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.31,0C3.28,0,0,3.28,0,7.31s3.28,7.31,7.31,7.31,7.31-3.28,7.31-7.31S11.35,0,7.31,0ZM10.98,3.72l-2.78,6.83c-.26.63-.87,1.04-1.55,1.04s-1.24-.37-1.51-.96l-1.43-3.03c-.32-.78.25-1.63,1.09-1.63.5,0,.94.31,1.11.78l.81,2.05,1.48-4.13c.35-.98,1.28-1.63,2.32-1.63.35,0,.58.35.45.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.37de85a3830bdaf3858700b0192e676b.svg";
export { ForwardRef as ReactComponent };